import React, { useContext, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow
} from '@mui/material';
import Moment from 'react-moment';
import { DispatchContext, StateContext } from '../../../store';
import { deaccessionApi } from '../../../services/DeaccessionServices';
import { truncate } from '../../../common/Functions/Truncate/Truncate';
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import PageWrapper from '../../../common/PageWrapper/PageWrapper';

export default function DeaccessionMain() {
  const dispatch = useContext(DispatchContext);
  const { role } = useContext(StateContext);
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState({ total: 0 });
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [deaccessions, setDeaccessions] = useState([]);
  const isAdminOrChief = role?.id === 1 || role?.id === 10;

  useEffect(() => {
    getDeaccession();
  }, [page, rowsPerPage]);

  const getDeaccession = () => {
    deaccessionApi('get', null, { page: page, per_page: rowsPerPage }).then(res => {
      setDeaccessions(res?.data);
      setMeta(res?.meta);
    })
  }

  const handleOpen = () => {
    navigate('/management/artifact-managements/deaccession-create');
  };

  const deaccessionDetail = (id) => {
    navigate(`/management/deaccessions/${id}`);
  }

  const handleChangePage = (event, newPage) => {
    dispatch({ type: 'IS_NOT_LOADING', payload: false });
    setPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  }

  return (
    <PageWrapper>
      <Box>
        <Box sx={{ background: '#ffffff', borderRadius: 2, p: 2 }}>
          {/* {isAdminOrChief &&
            <Typography sx={{ mt: 1, mb: 2, ml: 10 }} className={'museum-font'}>Deaccession</Typography>
          } */}
          <Box>
            <Grid container spacing={2}>
              <Grid item sm={6}>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <AutoModeIcon sx={{ color: '#ff9653', fontSize: 50 }} />
                  <Box>
                    <Box className={'flex-cx-center'} sx={{ display: 'flex', flexDirection: 'column' }}>
                      <Typography sx={{mr:4}}className={'museum-font'} variant='h6'>Deaccession</Typography>
                      <Box sx={{display:'flex', flexDirection:"row", gap:1, ml:1}}>
                        <Typography>
                          {meta?.total || 0}
                        </Typography>
                        <Typography>Total Deaccession</Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Grid>
              <Grid item sm={6} sx={{ textAlign: 'right' }}>
                {role?.id === 2 &&
                  <Button onClick={handleOpen} className={'text-capitalize border-radius-100'}
                    variant={'contained'}
                    color={'primary'}
                  >
                    + Deaccession Request
                  </Button>
                }
              </Grid>
            </Grid>
          </Box>
        </Box>
        {/* <Box className={'header-divider'} /> */}
        <div>
          <TableContainer className={'box-shadow'} component={Paper} sx={{ mt: 3 }}>
            <Table sx={{ minWidth: 650 }} aria-label="caption table">
              <TableHead>
                <TableRow>
                  <TableCell align="left" sx={{ color: '#B3B3B3', width: 20 }}>Sl.No</TableCell>
                  <TableCell align="left" sx={{ color: '#B3B3B3' }}>Submission Date</TableCell>
                  <TableCell align="left" sx={{ color: '#B3B3B3' }}>Accession No.</TableCell>
                  <TableCell align="left" sx={{ color: '#B3B3B3' }}>Created by</TableCell>
                  <TableCell align="left" sx={{ color: '#B3B3B3' }}>Museum</TableCell>
                  <TableCell align="left" sx={{ color: '#B3B3B3' }}>Status</TableCell>
                  <TableCell align="left" sx={{ color: '#B3B3B3' }}>Justification</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {deaccessions?.length > 0 && deaccessions?.map((deaccession, index) => (
                  <TableRow hover key={index}>
                    <TableCell align="left" sx={{ color: '#3D3D3D', width: 20 }}
                      onClick={() => deaccessionDetail(deaccession?.id)}>
                      {index + 1}
                    </TableCell>
                    <TableCell align="left" sx={{ color: '#3D3D3D' }}
                      onClick={() => deaccessionDetail(deaccession?.id)}>
                      <Moment format={'ll'}>{deaccession?.submission_date}</Moment>
                    </TableCell>
                    <TableCell align="left" sx={{ color: '#3D3D3D' }}
                      onClick={() => deaccessionDetail(deaccession?.id)}>
                      {deaccession?.accession_no}
                    </TableCell>
                    <TableCell align="left" sx={{ color: '#3D3D3D' }}
                      onClick={() => deaccessionDetail(deaccession?.id)}>
                      {deaccession?.user_name}
                    </TableCell>
                    <TableCell align="left" sx={{ color: '#3D3D3D' }}
                      onClick={() => deaccessionDetail(deaccession?.id)}>
                      {deaccession?.museum_name}
                    </TableCell>
                    <TableCell className={'text-capitalize'} align="left" sx={{ color: '#3D3D3D' }}
                      onClick={() => deaccessionDetail(deaccession?.id)}>
                      {deaccession?.state}
                    </TableCell>
                    <TableCell align="left" sx={{ color: '#3D3D3D' }}
                      onClick={() => deaccessionDetail(deaccession?.id)}>
                      {truncate(deaccession?.justification, 30)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 100]}
            page={page - 1}
            rowsPerPage={rowsPerPage}
            component="div"
            count={meta?.total}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </Box>
    </PageWrapper>
  );
}